import apiClient from "../../../utilities/apiClient";

export const signin = (payload) => {
  return apiClient.post(`${apiClient.Urls.signin}`, payload);
};

export const signout = () => {
  return apiClient.post(`${apiClient.Urls.signout}`, {}, true); // Pass true for auth to send cookie/auth headers
};

export const tenantCheck = (payload) => {
  return apiClient.get(`${apiClient.Urls.check_tenant}`, payload);
};
